'use strict';

angular.module('ufcw')
  .controller('QrController', function ($rootScope,$localstorage,$translate) {
    var vm = this;
    vm.errorMsg = null;

    vm.user  = $localstorage.getObject('user');
    vm.QRFromS3 = $localstorage.get('QRFromS3');
    
    $rootScope.headLander = true;
    $rootScope.titulopagina = $translate.instant("Código de Ingreso");



    

  });